export default __webpack_public_path__ + "static/media/turkey.f8ea1329.jpg";